class Update {
  constructor () {
    this.onEvent = this.onEvent.bind(this)
    this.register = this.register.bind(this)
    this.unRegister = this.unRegister.bind(this)
    this.init = this.init.bind(this)

    this.event = null
    this.callbacks = []
    this.isInit = false

    this.date = new Date()
    this.lastDate = this.date.getTime()
  }

  init () {
    if (!this.isInit) {
      this.onEvent()
      this.isInit = true
    }
  }

  register (callback, id) {
    if (typeof callback !== 'function') {
      console.warn(callback + ' is not a function on ' + this.constructor.name + '.register')
      return
    }
    if (id === void 0) {
      console.warn('Id is not defined')
      return
    }

    return this.callbacks.push({
      id: id,
      callback: callback
    })
  }

  unRegister (id) {
    let index = this.findCallbackIndex(id)

    if (index !== null) {
      this.callbacks.splice(index, 1)
    }
  }

  onEvent () {
    this.date = new Date()
    let currentDate = this.date.getTime()
    let delta = currentDate - this.lastDate

    this.callCallbacks(delta > 50 ? 16 : delta)

    this.lastDate = currentDate

    requestAnimationFrame(this.onEvent)
  }

  callCallbacks (event) {
    for (let i = 0; i < this.callbacks.length; i++) {
      this.callbacks[i].callback(event)
    }
  }

  findCallbackIndex (id) {
    for (let i = 0; i < this.callbacks.length; i++) {
      if (this.callbacks[i].id === id) { return i }
    }
  }
}

export default new Update()
